import listActions from 'src/modules/clasificacionTercero/list/clasificacionTerceroListActions';
import ClasificacionTerceroService from 'src/modules/clasificacionTercero/clasificacionTerceroService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'CLASIFICACIONTERCERO_DESTROY';

const clasificacionTerceroDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_STARTED,
      });

      await ClasificacionTerceroService.destroyAll([id]);

      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.clasificacionTercero.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/clasificacion-tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_ALL_STARTED,
      });

      await ClasificacionTerceroService.destroyAll(ids);

      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.clasificacionTercero.destroyAll.success'),
      );

      getHistory().push('/clasificacion-tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: clasificacionTerceroDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default clasificacionTerceroDestroyActions;
